import { getData } from "./data";
import React, { useContext, useEffect } from "react";
import * as S from "./style";
import Image from '../../../../app/js/components/loggedout/common/Image';
import { Link } from "react-router-dom";
import { whiteLilac } from '../../../../app/js/components/loggedout/shared-styles/Colors';
import Routes from '../../routes/routes';
import { SemContext } from "../../context/SemContext";

const Testimonial = ({trackPromoPageEvents}) => {
  const data = getData();
  const { state } = useContext(SemContext);
  const cta_text = (state.settings && state.settings.button_text) || "Try for free";

  // [AI GENERATED CODE]
  // Injects preconnect hint + KidSafe seal script on mount for faster badge load
  useEffect(() => {
    if (!document.querySelector('link[href="https://kidsafe.com"][rel="preconnect"]')) {
      const preconnect = document.createElement('link');
      preconnect.rel = 'preconnect';
      preconnect.href = 'https://kidsafe.com';
      document.head.appendChild(preconnect);
    }
    if (!document.getElementById('ksp-seals-script')) {
      const script = document.createElement('script');
      script.id = 'ksp-seals-script';
      script.async = true;
      script.setAttribute('data-product', 'okHgakwZiV7ujcdz8unVrzpsyOGLhyPpuQCgB36R');
      script.src = 'https://kidsafe.com/js/seals/seals.js';
      document.body.appendChild(script);
    }
  }, []);

  return (
    <S.Wrapper>
      <S.InfoContainer>
        {/* [AI GENERATED CODE] KidSafe seal rendered via JS snippet; script injected in useEffect */}
        <S.ImageWrapper>
          <div id="ksp-seals"></div>
        </S.ImageWrapper>
        <S.ContentTitle>Trusted By 40 million families</S.ContentTitle>
      </S.InfoContainer>
      <S.ContentWrapper>
        {
          data && data.map((item, idx) => {
            return (
              <S.InfoWrapper key={idx}>
                <S.InfoTitle>
                  {item.title}
                </S.InfoTitle>
                <S.InfoItem>
                  <S.InfoIcon>
                    <Image src={item.image} isCdnImage={item.isCdnImage} />
                  </S.InfoIcon>
                  <S.InfoDetails>
                    <S.InfoName>{item.name}</S.InfoName>
                    <S.InfoDesignation>{item.designation}</S.InfoDesignation>
                  </S.InfoDetails>
                </S.InfoItem>
              </S.InfoWrapper>
            )
          })
        }
      </S.ContentWrapper>
      <S.ButtonWrapper>
        <S.CTAOfferButton hoverColor={whiteLilac}>
          <Link to={Routes.PURCHASE_ROUTE} onClick={() => trackPromoPageEvents("Promo Page Interacted", {'clicked_on': 'CTA2' }, true)}>
            {cta_text}
          </Link>
        </S.CTAOfferButton>
      </S.ButtonWrapper>
    </S.Wrapper>
  )
}

export default Testimonial;